/**
 * @fileoverview Inline TextField mode for TaskInputQuick.
 */
import { Box, TextField } from '@mui/material';
import { TaskInputTokenPreview } from '@/features/tasks/components/forms/TaskInputTokenPreview';

const FOCUSED_OUTLINE_SX = {
  '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
    borderColor: 'secondary.main',
  },
};

const TaskInputQuickInline = ({
  fieldPlaceholder,
  inputValue,
  setInputValue,
  handleInlineKeyDown,
  handleInlineBlur,
  showTokenPreview,
  parsedPreview,
}) => (
  <Box sx={{ width: '100%' }}>
    <TextField
      fullWidth
      autoFocus
      variant="outlined"
      size="small"
      placeholder={fieldPlaceholder}
      value={inputValue}
      onChange={(e) => setInputValue(e.target.value)}
      onKeyDown={handleInlineKeyDown}
      onBlur={handleInlineBlur}
      sx={FOCUSED_OUTLINE_SX}
    />
    {showTokenPreview ? (
      <TaskInputTokenPreview parsed={parsedPreview} dense />
    ) : null}
  </Box>
);

export default TaskInputQuickInline;
